import { Button, Modal } from "react-bootstrap";
import SimpleBar from "simplebar-react";
import Textbox from "../form/textbox";
import { useEffect, useState } from "react";
import stringUtilities from "../../utilities/stringUtilities";


export default function FolderModal(props) {

    const [name, setName] = useState("");

    const [canSave, setCanSave] = useState(false);

    const onCancel = function () {
        if (props.onCancel) {
            props.onCancel();
        }
    }

    const onSave = function () {
        if (props.onSave) {
            props.onSave(name);
        }
    }

    useEffect(() => {
        setCanSave(!stringUtilities.isNullOrEmpty(name))
    }, [name])

    return <Modal show onHide={onCancel} centered>
        <Modal.Header closeButton>
            <Modal.Title>{props.parentName ? `Add folder to ${props.parentName}` : "Add folder"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <SimpleBar autoHide={false} className='simplebar-no-autohide pe-3' style={{ height: '150px' }}>
                <Textbox label="Name" value={name} onChange={setName} />
            </SimpleBar>
        </Modal.Body>
        <Modal.Footer>
            <Button size="sm" variant='secondary' onClick={onCancel}>Cancel</Button>
            <Button size="sm" variant='primary' onClick={onSave} disabled={!canSave}>Save</Button>
        </Modal.Footer>
    </Modal>
}
